var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "url(#paint0_linear_153_5389)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.625 26H39.9375V22.5714C39.9375 17.84 36.1575 14 31.5 14C26.8425 14 23.0625 17.84 23.0625 22.5714V26H21.375C19.5187 26 18 27.5429 18 29.4286V46.5714C18 48.4571 19.5187 50 21.375 50H41.625C43.4813 50 45 48.4571 45 46.5714V29.4286C45 27.5429 43.4813 26 41.625 26ZM31.5 41.4286C29.6438 41.4286 28.125 39.8857 28.125 38C28.125 36.1143 29.6438 34.5714 31.5 34.5714C33.3562 34.5714 34.875 36.1143 34.875 38C34.875 39.8857 33.3562 41.4286 31.5 41.4286ZM36.7313 26H26.2687V22.5714C26.2687 19.64 28.6144 17.2571 31.5 17.2571C34.3856 17.2571 36.7313 19.64 36.7313 22.5714V26Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_153_5389",
    x1: 0,
    y1: 0,
    x2: 64,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93F090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60BFB7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsPassword);
export default __webpack_public_path__ + "static/media/settings_password.3f63c6af5c9df0357e60c539f0a1354e.svg";
export { ForwardRef as ReactComponent };